"use client";

import { motion } from "motion/react";
import Link from "next/link";

import { ProductImage } from "@/components/catalog/product-image";
import { useSubtleInteraction } from "@/components/ui/motion-primitives";
import type { CatalogFamilySummary } from "@/domain/catalog/catalog-product";

const MotionLink = motion.create(Link);

export interface CategoryCardProps {
  readonly family: CatalogFamilySummary;
}

export function CategoryCard({ family }: Readonly<CategoryCardProps>) {
  const interaction = useSubtleInteraction();

  return (
    <MotionLink
      className="flex h-36 w-32 shrink-0 flex-col rounded-xl border border-outline-variant bg-surface p-2.5 shadow-sm outline-none focus-visible:border-primary focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 md:w-full md:shrink"
      href={`/categorias/${family.slug}`}
      prefetch={false}
      {...interaction}
    >
      <span className="flex h-20 items-center justify-center overflow-hidden rounded-lg bg-white p-[0px]">
        <ProductImage alt={family.name} imageUrl={family.featuredImageUrl} />
      </span>
      <span className="mt-2 line-clamp-2 min-h-9 text-center text-[13px] font-extrabold leading-[18px] text-primary-container">
        {family.name}
      </span>
    </MotionLink>
  );
}
